import React from 'react';
import { Tabs } from '@mui/material';

export default ({ children }: { children?: React.ReactNode }) => (
    <Tabs
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
        value={false}
        sx={{
            flexGrow: 4,
            '& .MuiTabScrollButton-root.Mui-disabled': {
                display: 'none',
            },
        }}
    >
        {children}
    </Tabs>
);
